import { useMediaQuery } from 'react-responsive'
import CircularButtons from '../../components/CircularButtons/index'
import MobileMenu from '../../components/MobileMenu'

export default function Home() {
  const isMobile = useMediaQuery({ maxWidth: 768 })

  return <div>{isMobile ? <MobileMenu /> : <CircularButtons />}</div>
}
